import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { AppRoutes } from "./app-routes";
import { ReleaseChecker } from "./release-checker";

// ✅ Extend MUI theme types so DataGrid overrides are recognized
declare module "@mui/material/styles" {
  interface Components {
    MuiDataGrid?: {
      styleOverrides?: {
        root?: React.CSSProperties;
      };
    };
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#5AAB61",
    },
    secondary: {
      main: "#e0e0e0",
    },
  },
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
        },
      },
    },
  },
});

function App() {
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <Router>
              <AppRoutes />
              <ReleaseChecker />
            </Router>
          </ThemeProvider>
        </StyledEngineProvider>
      </LocalizationProvider>
    </div>
  );
}

export default App;
